import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Alert, Button, Card, CardContent, CardHeader, CardTitle, Input } from '@lms/ui';
import { api } from '@/lib/api';

interface ForgotForm {
  email: string;
}

export function ForgotPasswordPage() {
  const { register, handleSubmit } = useForm<ForgotForm>();

  const mutation = useMutation({
    mutationFn: (values: ForgotForm) =>
      api('/auth/forgot-password', { method: 'POST', body: values, auth: false }),
  });

  return (
    <div className="lms-auth-forgot flex min-h-screen items-center justify-center bg-surface px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Recuperar contraseña</CardTitle>
        </CardHeader>
        <CardContent>
          {mutation.isSuccess ? (
            <Alert variant="success">
              Si el correo existe, recibirás instrucciones para restablecer tu contraseña.
            </Alert>
          ) : (
            <>
              {mutation.error && (
                <Alert variant="danger" className="mb-4">
                  {(mutation.error as Error).message}
                </Alert>
              )}
              <form onSubmit={handleSubmit((v) => mutation.mutate(v))} className="flex flex-col gap-4">
                <Input
                  label="Correo electrónico"
                  type="email"
                  autoComplete="email"
                  {...register('email', { required: true })}
                />
                <Button type="submit" loading={mutation.isPending} className="w-full">
                  Enviar enlace
                </Button>
              </form>
            </>
          )}
          <p className="mt-4 text-center text-sm text-on-surface-variant">
            <Link to="/login" className="font-medium text-primary hover:underline">
              Volver al inicio de sesión
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
